import {MenuVoiceFunction} from "./MenuVoiceFunction";

export class MenuVoice {
  /**
   * id
   */
  id?: number;
  /**
   * Name of the menu group
   */
  name!: string;
  /**
   * OrderIndex
   */
  orderIndex!: number;
  /**
   * icon
   */
  functions!: MenuVoiceFunction[];

  constructor() {
    this.functions = new Array<MenuVoiceFunction>();
  }
}
